import { Icon } from '@client:common/icon';

import './InvalidInputIndicator.light.scss';
import './InvalidInputIndicator.dark.scss';

export function InvalidInputIndicator() {
  return (
    <div className='invalid-input-indicator'>
      <Icon
        icon='report_problem'
        style='outlined' />
      <p>
        <strong>Warning: invalid input</strong>
      </p>
      <p>Ranking is currently unavailable</p>
    </div>
  );
}
